import live from '../../../../config/static_data/seasons/live.json'
import classicAnniversary from '../../../../config/static_data/seasons/classic_anniversary.json'
import classicEra from '../../../../config/static_data/seasons/classic_era.json'
import classicProgression from '../../../../config/static_data/seasons/classic_progression.json'

export type SeasonEntry = {
  id: number
  name: string
  start_date: string
  end_date: string | null
  game_version: string
  expansion: string
  first_period_id?: number
  tier_id: number
  tier_items_by_slot?: {
    [classId: string]: {
      [slot: string]: number
    }
  }
  metadata: {
    keystone_dungeons?: {
      id: number | null
      name: string
      key?: string
      background?: string
      mythic_id: number | null
      legacy: boolean
    }[]
    catalyst_charge_achievement_id?: number
  }
}

const byGameVersion: Record<string, SeasonEntry[]> = {
  live: live as SeasonEntry[],
  classic_anniversary: classicAnniversary as SeasonEntry[],
  classic_era: classicEra as SeasonEntry[],
  classic_progression: classicProgression as SeasonEntry[],
}

export function getSeasonData(
  gameVersion: wowaudit.PageInfo['gameVersion'],
): SeasonEntry[] {
  return byGameVersion[gameVersion] ?? []
}
